const V = {
  idcard: (idcard?: string): boolean => {
    if (idcard?.length != 18) {
      return false;
    }
    const arr = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    let sum = 0;
    for (let i = 0; i < arr.length; i++) {
      sum += parseInt(idcard.charAt(i)) * arr[i];
    }
    const c = sum % 11;
    const ch = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    const code = ch[c];
    let last = idcard.charAt(17);
    last = last === 'x' ? 'X' : last;
    return last === code;
  },
  mobile: (mobile?: string): boolean => {
    // 1 开头的 11 位数字
    const reg = /^1[0-9]{10}$/;
    if (mobile && reg.test(mobile)) {
      return true;
    }
    return false;
  },
  telephone: (telephone?: string): boolean => {
    // 0开头10-12 位数字
    const reg = /^0[1-9][0-9]{8,10}$/;
    if (telephone && reg.test(telephone)) {
      return true;
    }
    return false;
  },
  account: (account?: string): boolean => {
    // 国内手机号 + 新加坡手机号
    const reg = /(^(1[3-9])\d{9}$)|(^\d{2}-\d{8}$)/;
    if (account && reg.test(account)) {
      return true;
    }
    return false;
  }
}
export default V;
